import { render, staticRenderFns } from "./LayoutBlank.vue?vue&type=template&id=c4b35c44&"
import script from "./LayoutBlank.vue?vue&type=script&lang=js&"
export * from "./LayoutBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cognatis/api/frontend/foundation/dev/webapp/vue-project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c4b35c44', component.options)
    } else {
      api.reload('c4b35c44', component.options)
    }
    module.hot.accept("./LayoutBlank.vue?vue&type=template&id=c4b35c44&", function () {
      api.rerender('c4b35c44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/LayoutBlank.vue"
export default component.exports